<template>
  <div class="player-container">
    <div class="action-header">
      <el-button type="primary" @click="handleGoPlayerReg">查看注册运动员</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="loginId">
        <template slot="header" slot-scope="scope">
          <div>账号</div>
          <el-input
            v-model="search.loginId"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="contact">
        <template slot="header" slot-scope="scope">
          <div>联系人</div>
          <el-input
            v-model="search.contact"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
      </el-table-column>
      <el-table-column
        prop="name">
        <template slot="header" slot-scope="scope">
          <div>会员单位名称</div>
          <el-input
            v-model="search.name"
            placeholder="搜索"
            @change="quickSearch"/>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatAudit"
        width="120"
        prop="status">
        <template slot="header" slot-scope="scope">
          <div>审核状态</div>
          <el-select v-model="search.status" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in auditStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope" >
          <el-select
            v-model="scope.row.status"
            filterable
            @change="reviseState('audit', scope)" >
            <el-option v-for="item in auditStateList" v-show="item.value!==''" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatPayment"
        width="120"
        prop="paymentStatus">
        <template slot="header" slot-scope="scope">
          <div>付费状态</div>
          <el-select v-model="search.paymentStatus" filterable @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in payStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
        <template slot-scope="scope" >
          <el-select
            v-model="scope.row.paymentStatus"
            filterable
            @change="reviseState('payment', scope)" >
            <el-option v-for="item in payStateList" v-show="item.value!==''" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="160"
        prop="payDate">
        <template slot="header" slot-scope="scope">
          <div>付费时间</div>
          <el-date-picker
            v-model="search.payDate"
            @change="quickSearch"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatDate"
        width="160"
        prop="createDate">
        <template slot="header" slot-scope="scope">
          <div>创建时间</div>
          <el-date-picker
            v-model="search.createDate"
            @change="quickSearch"
            type="date"
            placeholder="选择日期" />
        </template>
      </el-table-column>
      <el-table-column
        label="申请列表"
        width="80"
        prop="playerCount">
        <template slot-scope="scope">
          <div v-if="checkPermission(['user-club-apply'])" style="cursor: pointer;" @click="applicationList(scope.row.id)">
            <el-button type="text">{{ scope.row.playerCount }}</el-button>
          </div>
          <div v-else>
            {{ scope.row.playerCount }}
          </div>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            v-if="checkPermission(['user-club-edit'])"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            v-else
            @click="handleRead(scope.$index, scope.row)">查看</el-button>
          <el-button
            size="mini"
            type="danger"
            v-permission="['user-club-delete']"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="modalTitle" center>
      <el-form :model="dialogForm" :rules="rules" ref="dialogForm" class="modal" label-width="100px">
        <el-form-item label="登录账号" prop="mobile">
          <el-input v-model="dialogForm.mobile" :disabled="isEditMode"/>
        </el-form-item>
        <el-form-item label="选择身份" prop="membershipTypeId">
          <el-select v-model="dialogForm.membershipTypeId" filterable :disabled="isEditMode" placeholder="请选择">
            <el-option
              v-for="item in roleList"
              :key="item.id"
              :label="item.title"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="真实姓名">
          <el-input v-model="dialogForm.trueName" />
        </el-form-item>
        <el-form-item label="密码" prop="password">
          <el-input v-model="dialogForm.password" type="password" />
        </el-form-item>
        <el-form-item label="邮箱">
          <el-input v-model="dialogForm.email" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogVisibleSelectTime"
      :before-close="dialogHideSelectTime"
      title="提示"
      width="30%">
      <span class="demonstration">选择手动支付时间</span>
      <el-date-picker
        v-model="paymentTime"
        class="input-win"
        type="datetime"
        placeholder="选择日期">
      </el-date-picker>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogHideSelectTime">取 消</el-button>
        <el-button type="primary" @click="setPaymentStatus">确 定</el-button>
      </span>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>

import * as moment from 'moment'
import find from 'lodash/find'
import permission from '@/directive/permission/index.js' // 权限判断指令
import checkPermission from '@/utils/permission' // 权限判断函数
import { getClubList } from '@/api/club'
import { updateMembershipStatus, updatePaymentStatus } from '@/api/user'
import { getAuditList, getPaymentList } from '@/api/user'

const defaultForm = {}
const state = [
  { id: 0, label: '审核中' },
  { id: 1, label: '拒绝' },
  { id: 2, label: '通过' },
  { id: -1, label: '冻结' }
]

export default {
  name: 'PlayerList',
  directives: { permission },
  data() {
    return {
      search: {},
      list: [],
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      roleList: [],
      isEditMode: false,
      modalTitle: '',
      dialogForm: {},
      dialogVisible: false,
      formLabelWidth: '100px',
      auditStateList: [],
      payStatusList: [],
      imageUrl: '',
      rules: {
        mobile: [
          { required: true, message: '请输入登录账号', trigger: 'blur' },
          { pattern: /^1\d{10}$/, message: '目前只支持中国大陆的手机号码' }
        ],
        membershipTypeId: [
          { required: true, message: '请选择用户身份', trigger: 'blur' }
        ]
      },
      dialogFormVisible: false,
      dialogVisibleSelectTime: false,
      paymentStatusParams: {},
      paymentTime: null
    }
  },
  created() {
    if (this.$route.query.page) {
      this.currentPage = parseInt(this.$route.query.page, 10)
    }
    this.getList()
    this.getAuditList()
    this.getPaymentList()
  },
  computed: {
  },
  methods: {
    checkPermission,
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加用户信息'
      this.dialogForm = defaultForm
    },
    handleEdit(index, row) {
      this.$router.push({ name: 'ClubEdit', params: { id: row.id }})
    },
    handleRead(index, row) {
      this.$router.push({ name: 'ClubDetails', params: { id: row.id }})
    },
    handleGoPlayerReg() {
        this.$router.push({ name: 'ClubPlayerList' })
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该用户, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deletePlayer(this.list[index].id)
      }).catch(() => {
      })
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEditMode) {
            this.updatePlayer()
          } else {
            this.addPlayer()
          }
        } else {
          return false
        }
      })
    },
    handleCurrentChange(val) {
      this.$router.push({path: this.$route.path, query: {page: val}})
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      if (this.search.createDate) {
        this.search.createDate = moment(this.search.createDate).format('YYYY-MM-DD')
      }
      if (this.search.payDate) {
        this.search.payDate = moment(this.search.payDate).format('YYYY-MM-DD')
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getClubList(this.listQuery).then(response => {
        const data = response.data
        this.list = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },
    getPlayerById(userId) {
      getPlayerById(userId).then(response => {
        const data = response.data
        this.dialogForm = data.user
      })
    },
    addPlayer() {
      addPlayer(this.dialogForm).then(response => {
        const data = response.data
        if(data && data.player) {
          this.dialogVisible = false
          this.$message({
            message: '创建成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    updatePlayer() {
      const data = {
        userId: this.dialogForm.id,
        trueName: this.dialogForm.trueName,
        password: this.dialogForm.password,
        email: this.dialogForm.email
      }
      updatePlayer(data).then(response => {
        const data = response.data
        if(data) {
          this.$message({
            message: '更新成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    deletePlayer(userId) {
      const params = {
        id: userId,
        status: -2
      }
      updateMembershipStatus(params).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    getAuditList() {
      this.auditStateList = getAuditList()
    },
    getPaymentList() {
      this.payStateList = getPaymentList()
    },
    formatAudit: function(row, column) {
      /*
      const value = row[column.property]
      const obj = find(this.auditStateList, function (item) {
        return item.value == value
      });
      return obj&&obj.label
      */
    },
    formatPayment: function(row, column) {
      const value = row[column.property]
      const obj = find(this.payStateList, function (item) {
        return item.value == value
      });
      return obj&&obj.label
    },
    formatDate: function(row, column) {
      const date = row[column.property]
      return date && moment(date).format('YYYY-MM-DD HH:mm:ss')
    },
    reviseState(type, status) {
      let params = this.paymentStatusParams = {
        id: status.row.id,
        status: status.row.status,
        remark: '' // TODO
      }
      if (type === 'payment') {
        params.paymentStatus = status.row.paymentStatus
        if (status.row.paymentStatus === 2) {
          this.dialogVisibleSelectTime = true
        } else {
          this.updatePaymentStatus(params)
        }
      } else if (type === 'audit') {
        if (status.row.status === 1) {
          this.$prompt('请输入审核未通过原因', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            beforeClose: (action, instance, done) => {
              if (action === 'cancel') {
                this.getList()
                done()
              } else if (action === 'confirm') {
                done()
              }
            }
          }).then(({ value }) => {
            params.remark = value
            this.updateMembershipStatus(params)
          }).catch(() => {
            return false
          })
        } else {
          this.updateMembershipStatus(params)
        }
      }
    },
    updateMembershipStatus(param) {
      const params = param
      updateMembershipStatus(params).then((resolve) => {
        this.$message({
          message: '审核状态修改成功',
          type: 'success'
        })
      }, (reject) => {
        this.$message({
          message: '审核状态修改失败',
          type: 'error'
        })
      })
    },
    updatePaymentStatus(params) {
      updatePaymentStatus(params).then((res) => {
        if (res.data) {
          this.$message({
            message: '支付状态修改成功',
            type: 'success'
          })
          this.getList()
        }
      }, (err) => {
        this.$message({
          message: '支付状态修改失败',
          type: 'error'
        })
      })
    },
    dialogHideSelectTime() {
      this.getList()
      this.dialogVisibleSelectTime = false
    },
    setPaymentStatus() {
      this.paymentStatusParams.payDate = this.paymentTime || moment().format('YYYY-MM-DDTHH:mm:ss+0800')
      this.updatePaymentStatus(this.paymentStatusParams)
      this.dialogVisibleSelectTime = false
    },
    applicationList(clubId) {
      this.$router.push({
        path: `/club/application-list/${clubId}`
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .player-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
      th>{
        .cell {
          text-overflow: clip;
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }
  }
</style>
